// 入力系メッセージ
export const MSG_INPUT_REQUEST_INPUT = "{0}を入力してください"
export const MSG_INPUT_REQUEST_SELECT = "{0}を選択してください"
export const MSG_INPUT_MISS_REQUIRED = "※全ての項目を正しく入力してください";
export const MSG_INPUT_OVER_MAXLENGTH = "全角{0}文字（半角{1}文字）以内で入力してください";

// 業務系メッセージ
export const MSG_LOGIC_EMPTY_LIST = "対象{0}に{1}がありません"
export const MSG_LOGIC_INSERT_FINISH = "{0}を追加しました"
export const MSG_LOGIC_UPDATE_FINISH = "{0}を更新しました"
export const MSG_LOGIC_DELETE_FINISH = "{0}を削除しました"
export const MSG_LOGIC_INSERT_FAILED = "{0}の追加に失敗しました"
export const MSG_LOGIC_UPDATE_FAILED = "{0}の更新に失敗しました"
export const MSG_LOGIC_DELETE_FAILED = "{0}の削除に失敗しました"
